import { Trans, useLingui } from '@lingui/react'
import classNames from 'clsx'
import { type FC } from 'react'

import nowLogo from 'views/assets/images/logos/logo-now.svg'
import Image from 'views/components/atoms/Image'
import TransWithHtml from 'views/components/utils/TransWithHtml'

import NowContentIsEligible from './NowContentIsEligible'
import './NowWithDeliveryTimeCaseBox.scss'
import { useNowWithDeliveryTimeCaseBox } from './useNowWithDeliveryTimeCaseBox'

const NowWithDeliveryTimeCaseBox: FC = () => {
  const {
    deliveryTime,
    deliveryDay,
    timeLeft,
    isNowEligible,
    hasNotEligibleReason,
    hasNotInDeliveryRegion,
    hasMinimumValueNotReached,
    hasNoAvaliableSlot,
    dataQAid,
    diffPrice,
  } = useNowWithDeliveryTimeCaseBox()
  const { i18n } = useLingui()

  return (
    <section
      data-qa-id={`now-with-delivery-time-case-box-${dataQAid}`}
      className={classNames('m-NowWithDeliveryTimeCaseBox__container', {
        'm-NowWithDeliveryTimeCaseBox__container--is-eligible': isNowEligible,
        'm-NowWithDeliveryTimeCaseBox__container--has-not-in-delivery-region':
          hasNotInDeliveryRegion,
        'm-NowWithDeliveryTimeCaseBox__container--has-not-eligible-reason':
          hasNotEligibleReason ||
          hasMinimumValueNotReached ||
          hasNoAvaliableSlot,
      })}
    >
      <Image src={nowLogo} alt="NOW logo" width={37} height={31} />
      <article className={'m-NowWithDeliveryTimeCaseBox__article'}>
        {isNowEligible && (
          <NowContentIsEligible
            deliveryTime={deliveryTime}
            deliveryDay={deliveryDay}
            timeLeft={timeLeft}
          />
        )}

        {hasNotInDeliveryRegion && (
          <Trans
            id={'general.label.now.collapsible.error.not_in_delivery_region'}
          />
        )}

        {hasNotEligibleReason && (
          <Trans
            id={'general.label.now.collapsible.error.product_not_available'}
          />
        )}

        {hasMinimumValueNotReached && (
          <TransWithHtml
            text={i18n._(
              'general.label.now.collapsible.error.minimum_value_not_reached',
              { diffPrice }
            )}
          />
        )}

        {hasNoAvaliableSlot && (
          <Trans id={'general.label.now.collapsible.error.no_available_slot'} />
        )}
      </article>
    </section>
  )
}

export default NowWithDeliveryTimeCaseBox
